import {
  MarketingConversationTopic,
  QueueType,
} from "@redotech/redo-marketing-common/conversation/marketing-conversation-definition";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

/**
 * Queue counts for every (topic, queueType) queue in the recover bar, plus the
 * dedicated team's per-queueType counts (authorized callers only, no overlap).
 */
export const getAllQueueCounts = {
  name: "getAllQueueCounts" as const,
  input: z.object({}),
  output: z.object({
    counts: z.array(
      z.object({
        topic: createEnum(MarketingConversationTopic),
        queueType: createEnum(QueueType),
        count: z.number(),
      }),
    ),
    dedicatedCounts: z
      .array(z.object({ queueType: createEnum(QueueType), count: z.number() }))
      .optional(),
  }),
};
